import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QualifierValue } from "../../../../internal/qualifier/QualifierValue";
/**
 * @memberOf Qualifiers.Compass
 * @extends {SDK.QualifierValue}
 */

var CompassQualifier = /*#__PURE__*/function (_QualifierValue) {
  _inherits(CompassQualifier, _QualifierValue);

  var _super = _createSuper(CompassQualifier);

  function CompassQualifier(val) {
    var _this;

    _classCallCheck(this, CompassQualifier);

    _this = _super.call(this);
    _this.val = val;
    return _this;
  }

  _createClass(CompassQualifier, [{
    key: "toString",
    value: function toString() {
      return this.val;
    }
  }]);

  return CompassQualifier;
}(QualifierValue);

export { CompassQualifier };